import React from "react";
import Page from "../templates/support/childrin&education/spotlight/wow-iskole";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
